"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectShowPlans = exports.selectShowDevices = exports.selectShowBusinessSolutions = exports.selectDisplayedProducts = exports.selectComparisonSpecs = exports.selectComparableProductsList = void 0;
const selectComparableProductsList = instanceId => state => state.drools[instanceId].comparison.comparableProductsList;
exports.selectComparableProductsList = selectComparableProductsList;
const selectDisplayedProducts = instanceId => state => state.drools[instanceId].comparison.displayedProducts;
exports.selectDisplayedProducts = selectDisplayedProducts;
const selectComparisonSpecs = instanceId => state => state.drools[instanceId].comparison.specs;
exports.selectComparisonSpecs = selectComparisonSpecs;
const selectShowDevices = instanceId => state => state.drools[instanceId].comparison.showDevices;
exports.selectShowDevices = selectShowDevices;
const selectShowPlans = instanceId => state => state.drools[instanceId].comparison.showPlans;
exports.selectShowPlans = selectShowPlans;
const selectShowBusinessSolutions = instanceId => state => state.drools[instanceId].comparison.showBusinessSolution;
exports.selectShowBusinessSolutions = selectShowBusinessSolutions;